<template>
<!-- eslint-disable max-len -->
<div
  :class="{ 'decision-form': true, native: (native), sf: (starfighter) }"
  :style="{
    width: decision.decisionContainerWidthOverride ? decision.decisionContainerWidthOverride : undefined,
    'max-height': decision.decisionContainerMaxHeightOverride ? decision.decisionContainerMaxHeightOverride : undefined,
  }"
>
  <h1 v-if="!(decision.hideTitle)" class="form-header" style="width: 100%; margin: 0;" v-html="decision.displayTitle || decision.title"></h1>
  <div v-if="!(decision.hideTitle) || decision.description" class="description-bar">
    <div class="description" v-html="decision.description">
    </div>
  </div>
  <div :class="{ native, sf: (starfighter) }" class="decision-form-form" @input="onFormInput">
    <div
      v-for="(entry, i) in decision.formEntries"
      :key="i"
    >
      <template v-if="!(entry.displayConditionally) || checkDisplayCondition(i)">
        <div
          v-if="entry.type === 'employmentStartDate'"
          style="margin: 18px 0;"
        >
          <div
            style="font-size: 1.18rem; margin: 0 0 4px;"
            v-html="entry.prompt"
          ></div>
          <div
            style="display: flex; flex-flow: row wrap; align-items: center; font-size: 1.05rem;"
          >
            <select-input
              v-if="!(choices[i].applicant)"
              v-model="choices[i].month"
              label
              :options="[
                'January','February','March','April','May','June','July','August','September','October','November','December'
              ]"
              disable-sort
              style="flex-basis: 30%; flex-grow: 1; min-width: 150px; max-width: 175px; margin: 0 16px 0 0;"
            >Month</select-input>
            <select-input
              v-if="!(choices[i].applicant)"
              v-model="choices[i].year"
              label
              :options="getYearOptions(entry)"
              disable-sort
              style="flex-basis: 30%; flex-grow: 1; min-width: 110px; max-width: 120px; margin: 0 16px 0 0;"
              integer
            >Year</select-input>
            <checkbox-input
              v-model="choices[i].applicant"
              style="margin: 10px 0 0 5px;"
            >{{ entry.noDateCheckboxText ? entry.noDateCheckboxText : 'I haven\'t started role' }}</checkbox-input>
          </div>
        </div>
        <div
          v-else-if="entry.type === 'year'"
          style="margin: 18px 0; font-size: 1.18rem;"
        >
          <select-input
            v-model="choices[i]"
            label-html
            :options="getYearOptions(entry)"
            disable-sort
            placeholder="Select one..."
            integer
          >{{entry.prompt}}</select-input>
        </div>
        <div
          v-else-if="entry.type === 'range'"
          style="margin: 18px 0; font-size: 1.18rem;"
        >
          <select-input
            v-model="choices[i]"
            label-html
            :options="getRangeOptions(entry)"
            disable-sort
            placeholder="Select one..."
            integer
          >{{entry.prompt}}</select-input>
        </div>
        <div
          v-else-if="entry.type === 'freeResponse'"
          style="margin: 18px 0; font-size: 1.18rem;"
        >
          <text-input
            v-model="choices[i]"
            label
            no-count
            @focus="onFocus"
            @blur="onBlur"
          >{{entry.prompt}}</text-input>
        </div>
        <div
          v-else-if="entry.type === 'selection'"
          style="margin: 18px 0; font-size: 1.18rem;"
        >
          <select-input
            v-model="choices[i]"
            label-html
            :options="entry.choices"
            options-html
            disable-sort
            use="_id"
            display="title"
            placeholder="Select one..."
          >{{entry.prompt}}</select-input>
        </div>
      </template>
    </div>
  </div>
  <!-- {{ choices }} -->
  <div class="decision-form-controls">
    <button
      class="btn decision-form-submit"
      :disabled="!validInput"
      @click.prevent="submitForm"
      :tabindex="0"
    >
      <div v-html="submitButtonText ? submitButtonText : 'Submit'"></div>
    </button>
  </div>
</div>
</template>

<script>
// import Vue from 'vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';

import TextInput from '@/components/ui/inputs/TextInput';
import SelectInput from '../../ui/inputs/SelectInput';
import CheckboxInput from '../../ui/inputs/CheckboxInput';

export default {
  props: {
    decision: { type: Object },
    colors: { type: Array },
    selectedChoices: { type: Array },
    hasSubmitted: { type: Boolean },
    submitButtonText: { type: String },
  },
  components: {
    SelectInput,
    CheckboxInput,
    TextInput,
  },
  data() {
    return {
      choices: this.decision.formEntries.map(this.initializeChoice),
      formDisablesForcedLandscape: true,
    };
  },
  computed: {
    ...mapGetters([
      'roles',
      'allPlayers',
      'cash',
      'playerDecision',
      'playerGroupRole',
      'game',
      'starfighter',
      'native'
    ]),
    defaultYearOptions() {
      const res = [];
      for (let i = 0; i < 24; ++i) {
        res[i] = (new Date()).getUTCFullYear() - i;
      }
      return res;
    },
    validInput() {
      return (this.choices.length === this.decision.formEntries.length)
        && this.decision.formEntries.every((entry, i) => {
          if (this.checkDisplayCondition(i)) {
            if (entry.type === 'employmentStartDate') {
              return this.choices[i].applicant || (this.choices[i].month && this.choices[i].year);
            }
            return this.choices[i];
          }
          return true;
        });
    },
  },
  methods: {
    ...mapMutations([
      'setDisableForcedLandscape',
    ]),
    ...mapActions([
      'playSound',
    ]),
    playClick() {
      this.playSound({
        sound:
          this.decision.choiceSelectButtonSound
          || this.game.clickSoundOverride
          || this.resolveAssetPath('click_cut.mp3', 'ui/customer'),
      });
    },
    playChoiceInput() {
      const sound = (this.choiceDisplayType === 'carousel' && !(this.decision.choiceInputChangeSound))
        ? this.game.arrowButtonSound
        : this.decision.choiceInputChangeSound;
      if (sound) {
        this.playSound({ sound });
      }
    },
    // TODO: choice input off currently not supported... employment date start checkbox would be the only relevant thing for this
    playChoiceInputOff() {
      if (this.decision.choiceInputOffSound || this.decision.choiceInputChangeSound) {
        this.playSound({ sound: (this.decision.choiceInputOffSound || this.decision.choiceInputChangeSound) });
      }
    },
    onFocus() {
      if (!(this.formDisablesForcedLandscape)) {
        this.setDisableForcedLandscape(true);
      }
    },
    onBlur() {
      if (!(this.formDisablesForcedLandscape)) {
        this.setDisableForcedLandscape(false);
      }
    },
    onFormInput(ev) {
      if (!(ev.inputType === 'insertText')) { // suppress input change sound for free response entries
        this.playChoiceInput();
      }
    },
    async submitForm() {
      this.playClick();
      await new Promise(resolve => setTimeout(resolve, 250));
      const { choices } = this;
      this.$emit('input', { choices });
    },
    initializeChoice({ type }) {
      if (type === 'employmentStartDate') {
        return {
          month: '',
          year: '',
          applicant: false,
        };
      } else if (type === 'freeResponse') {
        return '';
      }
      return null;
    },
    checkDisplayCondition(index) {
      const entry = this.decision.formEntries[index];
      const dependentEntryIndex = index + entry.dependentEntryOffset;
      if (dependentEntryIndex < 0
        || dependentEntryIndex > this.decision.formEntries.length) {
        return true;
      }
      const dependentEntry = this.decision.formEntries[dependentEntryIndex];
      if (!dependentEntry
        || entry.dependentChoiceIndex < 0
        || entry.dependentChoiceIndex > dependentEntry.choices.length) {
        return true;
      }
      const dependentChoice = dependentEntry.choices[entry.dependentChoiceIndex];
      if (!dependentChoice) return true;
      const shouldDisplay = dependentChoice._id === this.choices[dependentEntryIndex];
      if (!shouldDisplay) {
        this.choices[index] = this.initializeChoice(entry);
      }
      return shouldDisplay;
    },
    getRangeOptions(entry) {
      const options = [];
      if (entry.startRange && entry.endRange) {
        let option = entry.startRange;
        if (entry.startRange > entry.endRange) {
          while (option >= entry.endRange) {
            options.push(option);
            option -= 1;
          }
        } else {
          while (option <= entry.endRange) {
            options.push(option);
            option += 1;
          }
        }
      }
      return options;
    },
    getYearOptions(entry) {
      if (entry.minYear) {
        const years = [];
        let year = entry.maxYear ? entry.maxYear : ((new Date()).getUTCFullYear());
        while (year >= entry.minYear) {
          years.push(year);
          year -= 1;
        }
        return years;
      }
      return this.defaultYearOptions;
    }
  },
  created() {
    if (this.hasSubmitted) {
      // eslint-disable-next-line no-restricted-syntax
      for (let i = 0; i < this.choices.length; ++i) {
        this.choices[i] = this.selectedChoices[i];
      }
    }
  },
  beforeMount() {
    if (this.formDisablesForcedLandscape) {
      this.setDisableForcedLandscape(true);
    }
  },
  beforeDestroy() {
    // make sure disable forced landscape can't get left on
    this.setDisableForcedLandscape(false);
  },
};
</script>

<style lang="scss" scoped>
.decision-form {
  position: absolute;
  width: 76.6%;
  min-height: 77.8%;
  max-height: 77.8%;
  padding: 20px;
  background-color: white;

  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
}

.decision-form.native
{
  display: flex;
  border: 25px solid rgba(0, 0, 0, 0);
  border-image: url('/static/ui/customer/B2_TextBox_90.png') 90 fill;
  transform: translateZ(0);
}

.decision-form h2 {
  display: inline-block;
  width: 380px;
  height: auto;
  margin: 0 20px 0 0;
}

.decision-form h2 img {
  width: 380px;
  height: 210px;
  margin-bottom: 15px;
  object-position: top left;
  object-fit: cover;
  border: 4px inset white;
}
.decision-form h2 article {
  height: 430px;
  padding: 15px;
}
.decision-form h2 article h1 {
  line-height: 36px;
  font-size: 32px;
  font-weight: bold;
  color: var(--primaryColor);
  overflow: auto;
  margin-bottom: 15px;
}
.decision-form h2 article p {
  line-height: 32px;
  font-size: 28px;
  font-weight: bold;
  color: black;
  overflow: auto;
}
.decision-form-description {
  overflow-y: auto;
}

.description-bar {
  margin-top: 10px;
  margin-left: -20px;

  display: flex;
  justify-content: space-between;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: white;
  width: calc(100% + 40px);
  background-color: var(--neutralColor);
}

.description {
  font-size: 1.15rem;
  width: 100%;
}

.decision-form-form {
  overflow-y: auto;
  width: 100%;
  flex-basis: 84.3%;
  flex-grow: 1;
  padding: 5px;
}

.decision-form-controls {
  width: 100%;
  padding: 8px 0 0;
  align-self: flex-end;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.decision-form .btn {
  width: 250px;
  height: 80px;
  font-size: 44px;
  line-height: 44px;
}
.decision-form-submit {
  float: right;
}

.form-header {
  font-weight: bolder;
}

.character-icon
{
  background-color: white;
  outline: 1px solid black;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/DecisionForm.vue